import ArticlesStore from "./ArticlesStore";
import TinyDriveTokenStore from "./TinyDriveTokenStore";

const articlesStore = new ArticlesStore();
export const tinyDriveTokenStore = new TinyDriveTokenStore();

export default articlesStore;
